export default {
  init() {
    this.parse();
    document.addEventListener('words.parse', () => this.parse());
  },

  parse() {
    if (document.readyState === 'loading') {
      setTimeout(() => this.parse(), 50)
      return
    }
    Array
      .from(document.querySelectorAll('.text-words'))
      .forEach((el) => {
        el.innerHTML = this.createWordsElements(el.textContent);
      });
  },

  createWordsElements(str) {
    if (!str) {
      return '';
    }
    const words = str.trim().replace(/\s\s+/g, ' ').split(' ');
    const wordsEls = [];
    words.forEach((word) => {
      wordsEls.push(`<div><span>${word}</span></div>`);
    });
    return wordsEls.join('&nbsp;');
  }
};
